import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  BreadcrumbModule,
  ModalModule,
  DropdownModule,
  LogoModule,
  NavbarModule,
  SidebarModule,
  LoaderModule,
  IconModule,
  TableModule,
  EmptyStateModule,
  CarouselModule,
  ContentTableModule,
  HeaderModule,
  LinkModule,
  PaginatorModule,
  PhoneNumberModule,
  StatusModule,
  TimelineModule,
  TimepickerModule,
  UploadModule
} from '@michelin/theme';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { CompanyFormComponent } from './components/forms/company-form/company-form.component';
import { SelectSearchInputComponent } from './components/fields/select-search-input/select-search-input.component';
import { ChartModule } from '@michelin/charts';
import { TranslateModule } from '@ngx-translate/core';

const modules = [
  TranslateModule,
  NgxMaskDirective,
  CommonModule,
  ReactiveFormsModule,
  FormsModule,
  BreadcrumbModule,
  DropdownModule,
  ModalModule,
  SidebarModule,
  NavbarModule,
  LogoModule,
  LinkModule,
  ChartModule,
  TimelineModule,
  TableModule,
  LoaderModule,
  PaginatorModule,
  IconModule,
  EmptyStateModule,
  UploadModule,
  StatusModule,
  ContentTableModule,
  CarouselModule,
  HeaderModule,
  TimepickerModule,
  PhoneNumberModule
];

const components = [CompanyFormComponent, SelectSearchInputComponent];

@NgModule({
  imports: [...modules],
  declarations: [...components],
  exports: [...modules, ...components],
  providers: [provideNgxMask()]
})
export class SharedModule {}
